import type { ColorScheme } from '../../types'

const tokens = (colorScheme: ColorScheme) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''
  return {
    hoverBg: `${prefix}interactive.icon-button-hover-bg`,
    text: `${prefix}text.primary`,
  }
}

export const toggleStyles = (isActive: boolean, colorScheme: ColorScheme) => {
  const t = tokens(colorScheme)
  return {
    alignItems: 'center' as const,
    bg: isActive ? t.hoverBg : 'transparent',
    // Icons render with `currentColor`, so this drives their color too.
    color: t.text,
    cursor: 'pointer' as const,
    gap: '8px',
    h: 'full',
    px: '16px',
    transition: 'background-color 0.2s ease-in-out',
    _hover: { bg: t.hoverBg },
  }
}

export const countStyles = {
  fontFamily: "'Soehne Kraftig', 'Söhne', sans-serif",
  fontSize: '20px',
  fontWeight: '600',
}
